<template>
    <v-col cols="12" sm="6" md="6" lg="8" xl="8">
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-toolbar-title>
                    {{ widget.body.title }}
                </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="orderTotals"
                    dense
                    :mobile-breakpoint="0"
                    hide-default-footer
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                {{ item.name }}
                            </td>
                            <td>
                                {{ item.currency }}
                            </td>
                            <td class="text-no-wrap">
                                {{ item.period1 }}
                            </td>
                            <td class="text-no-wrap">
                                {{ item.period2 }}
                            </td>
                            <td class="text-no-wrap">
                                {{ item.period3 }}
                            </td>
                            <td class="text-no-wrap">
                                {{ item.period4 }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import { findIndex } from 'lodash'

export default {
    name: 'ThreeMonthsTotalReport',
    props: {
        widget: {
            type: Object,
            default: null
        },
        permissions: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Waluta',
                    value: 'currency',
                    sortable: false
                },
            ],
            orderTotals:[],
            uniquePeriodHeaders:[]
        }
    },
    created() {
        this.createHeaders()
        this.compileData()
    },
    methods: {
        createHeaders() {
            const periodHeaders = this.widget.body.content.map(item => item.period)

            this.uniquePeriodHeaders = periodHeaders.filter((item, idx) => periodHeaders.indexOf(item) === idx)
            this.uniquePeriodHeaders.forEach(element => {
                this.headers.push({
                    text: element,
                    value: element,
                    sortable: false
                })
            })
        },
        compileData() {
            this.widget.body.content.forEach(element => {
                const currentIndex = findIndex(this.orderTotals, { 'name': element.name })

                if (currentIndex === -1) {
                    this.orderTotals.push({
                        name: element.name,
                        currency: element.currency,
                        period1: this.uniquePeriodHeaders.indexOf(element.period) === 0 ? element.totalPrice : '-',
                        period2: this.uniquePeriodHeaders.indexOf(element.period) === 1 ? element.totalPrice : '-',
                        period3: this.uniquePeriodHeaders.indexOf(element.period) === 2 ? element.totalPrice : '-',
                        period4: this.uniquePeriodHeaders.indexOf(element.period) === 3 ? element.totalPrice : '-',
                    })
                } else {
                    switch (this.uniquePeriodHeaders.indexOf(element.period)) {
                        case 0:
                            this.orderTotals[currentIndex].period1 = element.totalPrice
                            break
                        case 1:
                            this.orderTotals[currentIndex].period2 = element.totalPrice
                            break
                        case 2:
                            this.orderTotals[currentIndex].period3 = element.totalPrice
                            break
                        case 3:
                            this.orderTotals[currentIndex].period4 = element.totalPrice
                            break
                    }
                }
            })
        }
    }
}
</script>
